package org.vreo.devicehub.features.core.data.protocolBuffer.mappers

import vreo.volt.protocol.FrameRotation
import org.vreo.devicehub.features.core.domain.device.videoCameraConfig.VideoFrameRotation

/**
 * Converts a [VideoFrameRotation] to a [FrameRotation] proto enum.
 */
fun VideoFrameRotation.toFrameRotationProto(): FrameRotation {
    return when (this) {
        VideoFrameRotation.ROTATE_0 -> FrameRotation.ROTATE_0
        VideoFrameRotation.ROTATE_90 -> FrameRotation.ROTATE_90
        VideoFrameRotation.ROTATE_180 -> FrameRotation.ROTATE_180
        VideoFrameRotation.ROTATE_90_COUNTER_CLOCKWISE -> FrameRotation.ROTATE_90_COUNTER_CLOCKWISE
    }
}

/**
 * Converts a [FrameRotation] proto enum to a [VideoFrameRotation].
 */
fun FrameRotation.toVideoFrameRotation(): VideoFrameRotation {
    return when (this) {
        FrameRotation.ROTATE_0 -> VideoFrameRotation.ROTATE_0
        FrameRotation.ROTATE_90 -> VideoFrameRotation.ROTATE_90
        FrameRotation.ROTATE_180 -> VideoFrameRotation.ROTATE_180
        FrameRotation.ROTATE_90_COUNTER_CLOCKWISE -> VideoFrameRotation.ROTATE_90_COUNTER_CLOCKWISE
    }
}